import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkModeSubject = new BehaviorSubject<boolean>(false);

  constructor() {
    // Check for saved theme preference or default to light mode
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      this.darkModeSubject.next(true);
      this.applyDarkTheme();
    }
  }

  isDarkMode() {
    return this.darkModeSubject.asObservable();
  }

  getCurrentValue(): boolean {
    return this.darkModeSubject.value;
  }

  toggleDarkMode(): void {
    const currentValue = this.darkModeSubject.value;
    this.darkModeSubject.next(!currentValue);
    
    if (!currentValue) {
      this.applyDarkTheme();
      localStorage.setItem('theme', 'dark');
    } else {
      this.applyLightTheme();
      localStorage.setItem('theme', 'light');
    }
  }

  private applyDarkTheme(): void {
    document.body.classList.add('dark-theme');
  }

  private applyLightTheme(): void {
    document.body.classList.remove('dark-theme');
  }
}
